import React from 'react';
import { Card, CardHeader, CardContent, Paper, Stack, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, } from '@mui/material';
import { defineMessages, useIntl } from 'react-intl';
import StatusChip from './StatusChip';
import AttitudeChart from './AttitudeChart';
const msgs = defineMessages({
    headerTitle: {
        id: 'pages.member.vehicle.AttitudeCard.header.title',
        defaultMessage: 'Attitude',
    },
    headerSubTitle: {
        id: 'pages.member.vehicle.AttitudeCard.header.subTitle',
        defaultMessage: 'Attitude and gimbal of the vehicle',
    },
});
function AttitudeCard({ realtimeMetrics, lastMetrics }) {
    const intl = useIntl();
    const attitudes = realtimeMetrics?.filter((e) => e.attitude)?.map((e) => e.attitude);
    const gimbals = realtimeMetrics?.filter((e) => e.gimbal)?.map((e) => e.gimbal);
    const attitude = attitudes && attitudes.length > 0 ? attitudes[attitudes.length - 1] : lastMetrics?.attitude;
    const gimbal = gimbals && gimbals.length > 0 ? gimbals[gimbals.length - 1] : lastMetrics?.gimbal;
    return (React.createElement(Card, null,
        React.createElement(CardHeader, { title: intl.formatMessage(msgs.headerTitle), subheader: intl.formatMessage(msgs.headerSubTitle), action: React.createElement(StatusChip, { realtimeMetrics: realtimeMetrics, lastMetrics: lastMetrics, hasField: (e) => {
                    const metrics = e;
                    return !!metrics.attitude || !!metrics.gimbal;
                } }) }),
        React.createElement(CardContent, null,
            realtimeMetrics ? (React.createElement(Stack, { direction: "row", sx: { height: 120 } },
                React.createElement(AttitudeChart, { title: "Attitude", attitude: attitude }),
                React.createElement(AttitudeChart, { title: "Gimbal", attitude: gimbal }))) : null,
            React.createElement(TableContainer, { component: Paper, elevation: 0 },
                React.createElement(Table, null,
                    React.createElement(TableHead, null,
                        React.createElement(TableRow, null,
                            React.createElement(TableCell, null),
                            React.createElement(TableCell, { align: "right" }, "Pitch"),
                            React.createElement(TableCell, { align: "right" }, "Yaw"),
                            React.createElement(TableCell, { align: "right" }, "Roll"))),
                    React.createElement(TableBody, null,
                        React.createElement(TableRow, null,
                            React.createElement(TableCell, null, "Attitude"),
                            React.createElement(TableCell, { align: "right", "data-testid": "attitude-pitch" }, attitude?.pitch || attitude?.pitch === 0 ? `${attitude.pitch.toFixed(2)} \u33AD` : '-'),
                            React.createElement(TableCell, { align: "right", "data-testid": "attitude-yaw" }, attitude?.yaw || attitude?.yaw === 0 ? `${attitude.yaw.toFixed(2)} \u33AD` : '-'),
                            React.createElement(TableCell, { align: "right", "data-testid": "attitude-roll" }, attitude?.roll || attitude?.roll === 0 ? `${attitude.roll.toFixed(2)} \u33AD` : '-')),
                        React.createElement(TableRow, null,
                            React.createElement(TableCell, null, "Gimbal"),
                            React.createElement(TableCell, { align: "right", "data-testid": "gimbal-pitch" }, gimbal?.pitch || gimbal?.pitch === 0 ? `${gimbal.pitch.toFixed(2)} \u33AD` : '-'),
                            React.createElement(TableCell, { align: "right", "data-testid": "gimbal-yaw" }, gimbal?.yaw || gimbal?.yaw === 0 ? `${gimbal.yaw.toFixed(2)} \u33AD` : '-'),
                            React.createElement(TableCell, { align: "right", "data-testid": "gimbal-roll" }, gimbal?.roll || gimbal?.roll === 0 ? `${gimbal.roll.toFixed(2)} \u33AD` : '-'))))))));
}
export default React.memo(AttitudeCard);
